import React from 'react';
const Navnew = (props) => {
    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
            <div className="container-fluid">
                <a className="navbar-brand" href="/">FireCart</a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <a className="nav-link active" aria-current="page" href="/">Home</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/">About</a>
                        </li>
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" href="/" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                More
                            </a>
                            <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                <li><a className="dropdown-item" href="/">GitHub</a></li>
                                <li><a className="dropdown-item" href="/">Twitter</a></li>
                                <li><hr className="dropdown-divider" /></li>
                                <li><a className="dropdown-item" href="/">Portfolio</a></li>
                            </ul>
                        </li>
                        {/* <li className="nav-item">
          <a className="nav-link disabled">Disabled</a>
        </li> */}
                    </ul>
                    <form className="d-flex">
                        <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
                        <button className="btn btn-outline-success" type="submit">Search</button>
                        <img style={styles.cartIcon} src="https://github.com/DrCybernotix/FireCart/blob/main/imgs/totalcart.jpg?raw=true" alt="cart-icon" />
                        <span style={styles.cartCount}> {props.count} </span>
                    </form>
                </div>
            </div>
        </nav>
    );
}
const styles = {
    cartIcon: {
        height: 42,
        marginRight: 10
    },
    cartCount: {
        background: 'orange',
        borderRadius: '50%',
        padding: '2px 4px',
        position: 'absolute',
        right: 0,
        top: 0
    }
};

export default Navnew;